document.addEventListener('DOMContentLoaded', () => {
  const sizeChartTables = document.querySelectorAll('.size-chart__content table');
  sizeChartTables.forEach((table) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'size-chart__table';
    table.parentNode.appendChild(wrapper);
    wrapper.appendChild(table);
  });
});
